import { render, staticRenderFns } from "./PlatformSummary.vue?vue&type=template&id=482660d2&scoped=true"
import script from "./PlatformSummary.vue?vue&type=script&lang=js"
export * from "./PlatformSummary.vue?vue&type=script&lang=js"
import style0 from "./PlatformSummary.vue?vue&type=style&index=0&id=482660d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482660d2",
  null
  
)

export default component.exports